import { Pipe, PipeTransform } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { DEFAULT_CHANNEL_CODE } from '@vendure/common/lib/shared-constants';
import { OrderLine } from '../../common/generated-types';

@Pipe({
  name: 'multiplyByUnit',
})
export class LinePriceMultiplyPipe implements PipeTransform {
  transform(value: number, line: OrderLine): any {
    if (value !== 0 && !value) {
      return '';
    }
    let unitMultiplier = 1;
    const unit = line.customFields.unitOfMeasure.match(/\d+/);
    if (unit && unit[0]) {
      unitMultiplier = unit[0];
    }
    return value * unitMultiplier;
  }
}
